import { useContext, useMemo } from 'react'

import { isArray } from 'lodash'

import { GlobalContext } from '../../../Providers/GlobalProvider'
import EntitiesSelector from './EntitiesSelector'
import { sortByAbbreviation } from '../../../utils/entities/schoolSection'

const SectionsSelector = ({ disabled, empty = false, highlightValues = [], multiple, style = {}, sections = [], values, placeholder, onChange }) => {
  const gb = useContext(GlobalContext)

  const localSections = useMemo(() => {
    let localSections = []

    if (isArray(sections) && sections.length > 0) {
      localSections = sections.sort(sortByAbbreviation)
    } else if (isArray(gb?.sections)) {
      localSections = gb.sections
    }

    return localSections
  }, [gb?.sections, sections])

  const sectionOptions = useMemo(() => localSections.map(section => ({
    label: section.abbreviation,
    value: section.id,
    tooltip: section.name,
    entity: section
  })), [localSections])
  const toBeHighlighted = useMemo(() => highlightValues.map(s => s.id), [highlightValues])

  return (
    <EntitiesSelector
      placeholder={placeholder}
      disabled={disabled}
      entityOptions={sectionOptions}
      highlightValues={toBeHighlighted}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
      empty={empty}
    />
  )
}

export default SectionsSelector
